module.exports = __webpack_public_path__ + "static/media/1015053.32ccd737.jpg";